export default {
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.system': 'system',
  'menu.system-role-manage': 'Role Management',
  'menu.system.system-role-manage': 'Role Management',
  'menu.system-user-management': 'User Management',
  'menu.system.system-user-management': 'User Management',

  'countries.china': 'China',
  'countries.philippines': 'Philippines',
  'countries.usa_canada': 'USA/Canada',
  'countries.uk': 'UK',
  'countries.japan': 'Japan',
  'countries.south_korea': 'South Korea',
  'countries.singapore': 'Singapore',
  'countries.malaysia': 'Malaysia',
  'countries.thailand': 'Thailand',
  'countries.vietnam': 'Vietnam',
  'countries.indonesia': 'Indonesia',
  'countries.india': 'India',
  'countries.hong_kong': 'Hong Kong',
  'countries.macau': 'Macau',
  'countries.taiwan': 'Taiwan',

  memberManage: 'Member Management',
  tournamentManagement: 'Tournament Management',
  bonusManagement: 'Bonus Management',
  invitationManagement: 'Invitation Management',
  reportManage: 'Report Management',
  financeManage: 'Finance Management',
  platformManage: 'Platform Management',
  systemSet: 'System Settings',

  // ========== 路由 name 兜底文案（后端 menuName 缺失时使用）==========
  login: 'Login',
  // Member
  'member-manage': 'Member Management',
  'member-user-management': 'Member List',
  'member-hierarchical-management': 'Hierarchical Management',
  'member-signin-query': 'Sign-in Query',
  'member-sms-record': 'SMS Record',
  'member-kyc': 'KYC',
  // Tournament
  'tournament-manage': 'Tournament Management',
  'tournament-manage-hall': 'Hall',
  'tournament-manage-ticket': 'Ticket Management',
  'tournament-manage-ticket-record': 'Ticket Records',
  'tournament-manage-room': 'Room Inquiry',
  // Bonus
  'bonus-manage': 'Bonus Management',
  'bonus-manage-inquiry': 'Bonus Inquiry',
  'bonus-manage-template': 'Bonus Template',
  // Platform
  'platform-manage': 'Platform Management',
  'platform-manage-operLog': 'Operation Log',
  'banner-manage': 'Banner',
  'web-push-notifications': 'Web Push Notifications',
  'site-message-manage': 'Site Message',
  'registration-config': 'Registration Config',
  'sms-config': 'SMS Settings',
  'suspended-ball': 'Suspended Ball',
  'platform-manage-contactConfig': 'Social & Support',
  'channel-promotion': 'Promotion Channel',
  'burial-point-setting': 'Burial Point Setting',
  'burial-point-record': 'Burial Point Record',
  'promo-channel-manage': 'Channels',
  'promo-domain-manage': 'Domains',
  // System
  system: 'System Settings',
  'system-user-management': 'User Management',
  'system-role-manage': 'Role Management',
  'system-menu-config': 'Menu Management',
  'system-ip-whitelist': 'IP Whitelist',
  // Finance
  'finance-manage': 'Finance Management',
  'finan-outbound-review': 'Outbound Review',
  'finan-manual-funding': 'Manual Funding',
  'finan-payout-channel': 'Payout Channel',
  'finan-manual-instructions': 'Withdrawal Instructions',
  'finan-withdraw-limit': 'Withdrawal Limit',
  // Invitation
  'invitation-manage': 'Invitation Management',
  'invitation-manage-set': 'Invitation Settings',
  'invitation-manage-copywriting': 'Invitation Copywriting',
  'invitation-manage-tutorial': 'Invite Tutorial',
  // Report
  'report-manage': 'Report Management',
  'report-manage-moneyDetails': 'Money Details',
  'report-manage-operationsReport': 'Operations Report',
  'report-manage-retainedReport': 'Retained Report',
  'report-manage-onlineUsers': 'Online Users',
  // Activity
  'activity-benefits': 'Activity Management',
  'activity-benefits-settings': 'Activity Settings',
  'activity-benefits-review': 'Activity Review',
};
